var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shouyeLineEchart",staticStyle:{"background":"#fff","margin-top":"10px","padding-bottom":"10px"}},[_c('div',{staticClass:"echarts",attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }